import { useEffect, useRef } from "react";
import type { ModelCurrencyOverview } from "@/services/adminModelCurrency";
import { hasEvaluating } from "./helpers";

export const POLL_INTERVAL_MS = 10_000;

/** While any test is running, refetch the overview every 10 seconds; stop when none is. */
export function useOverviewPolling(
  overview: ModelCurrencyOverview | null,
  refresh: () => void | Promise<void>
) {
  const polling = hasEvaluating(overview);
  const inFlight = useRef(false);
  useEffect(() => {
    if (!polling) return;
    const timer = setInterval(() => {
      // A slow request must not pile up more requests behind it.
      if (inFlight.current) return;
      const pending = refresh();
      if (!pending) return;
      inFlight.current = true;
      void pending.finally(() => {
        inFlight.current = false;
      });
    }, POLL_INTERVAL_MS);
    return () => clearInterval(timer);
  }, [polling, refresh]);
}
